<div class="process-subscriptions-page">
  <div class="page-header page-header--no-search">
    <div class="page-header__title">
      <h2>{{ 'Assignments' | translate }}</h2>
      <p>{{ 'Manual process runs with full execution audit' | translate }}</p>
    </div>
  </div>
  <app-assignment-list></app-assignment-list>
</div>
